<template>
  <div class="cd-top-container">
    <div class="top">
      <BackButton to="members" back="/member" />
      <div class="flex-row-1 h-row-container">
        <div class="h-left-container">
          <div class="header">
            {{ customer.firstName }} {{ customer.lastName }}
          </div>
          <div class="sub-header">
            {{ serviceAddress.address1 }}
          </div>
          <div v-if="serviceAddress.address2" class="sub-header">
            {{ serviceAddress.address2 }}
          </div>
          <div class="sub-header">
            {{ serviceAddress.city }},
            {{ serviceAddress.state }},
            {{ serviceAddress.zip }}
          </div>
          <div class="sub-header">
            {{ customer.phone }}
          </div>
          <div class="sub-header">
            {{ customer.email }}
          </div>
        </div>
        <div class="h-right-container">
          <div class="flex-column align-end">
            <div v-if="isSmacAdmin" class="flex-row">
              <div class="header-container">
                <div class="header">
                  Partner Name
                </div>
                <div class="flex-row align-center justify-end">
                  <div class="sub-header mr-2">
                    {{ customer.companyName }}
                  </div>
                  <button
                    type="button"
                    class="edit-img-btn"
                    @click="toggleActionModal(true, 'change-partner')"
                  >
                    <img
                      class="edit-img"
                      src="@shared/assets/img/general/navy-edit.svg"
                      alt="navy-edit"
                    />
                  </button>
                </div>
              </div>
              <div class="header-container">
                <div class="header">
                  Member Type
                </div>
                <div class="sub-header-2">
                  {{ customer.membershipType || 'NA' }}
                </div>
              </div>
              <div class="header-container margin-left-16" v-if="customer?.membershipStart">
                <div class="header">
                  Membership Start
                </div>
                <div class="sub-header-2">
                  {{ dateWithoutHour(customer.membershipStart, dateAndYearFormat) }}
                </div>
              </div>
            </div>
            <div class="flex-row align-center">
              <div
                v-if="isSmacAdmin && subscription.length"
                class="header-container"
              >
                <div class="header">
                  Active Subscriptions
                </div>
                <div
                  v-for="(s, id) in subscription"
                  :key="id"
                  class="sub-header"
                >
                  {{ s.description }} x {{ s.quantity }}
                </div>
              </div>
              <div
                v-if="allCorpPlans.length > 0 || isSmacAdmin"
                class="header-container"
              >
                <div class="header">
                  SMART MAINTENANCE® Plan
                </div>
                <div class="flex-row align-center just-end">
                  <div
                    v-if="providerPlan.planId"
                    class="edit-provider-plan-container"
                  >
                    {{ providerPlan.name }}
                  </div>
                  <div v-else class="no-plan-container">
                    None
                  </div>
                  <button
                    type="button"
                    class="edit-img-btn"
                    @click="toggleActionModal(true, 'change-provider-plan')"
                  >
                    <img
                      class="edit-img"
                      src="@shared/assets/img/general/navy-edit.svg"
                      alt="navy-edit"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import BackButton from '@shared/components/BackButton.vue';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'TopInfo',
  components: {
    BackButton,
  },
  mixins: [customerDetailMixin, unitPreferencesMixin],
  computed: {
    serviceAddress() {
      if (this.customer && Array.isArray(this.customer.serviceAddress)) {
        return this.customer.serviceAddress[0];
      }
      return {}
    }
  },
};
</script>

<style lang="scss">
.cd-top-container {
  @include section-top-container;
  padding-top: 0;

  .top {
    @include section-top-content-container;
    display: flex;
    flex-direction: column;
    height: auto;

    .h-row-container {
      align-items: flex-end;
      justify-content: space-between;
    }

    .h-left-container {
      .header {
        color: $WHITE;
        font-weight: 700;
        font-size: 1.5625rem;
        margin-bottom: 8px;
      }

      .sub-header {
        font-size: 14.42px;
        font-weight: 500;
        color: $N60;
      }
    }

    .h-middle-container {
      width: 40%;

      .header {
        font-weight: 500;
        color: $N30;
      }

      .sub-header {
        font-size: 14.42px;
        font-weight: 500;
        color: $WHITE;
      }
    }
    .virtual-visit-record-btn {
      display: flex;
      flex-direction: row;
      background-color: $PRIMARY;
      width: 303px;
      padding: 10px;
      align-items: center;
      border-radius: 4px;
      margin: 14px 0;
    }
    .h-right-container {
      display: grid;
      grid-auto-flow: column;
      gap: 1rem;
      justify-content: flex-end;

      .header-container {
        margin-top: 8px;
        margin-bottom: 8px;

        &:first-child:nth-last-child(n + 2) {
          padding-right: 12px;
          margin-right: 12px;
          border-right: 1px solid $N90;
        }
      }

      .header {
        font-weight: 500;
        color: $N30;
        text-align: right;

        &.hover:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }

      .sub-header {
        font-size: 14.42px;
        font-weight: 500;
        color: $WHITE;
        text-align: right;
      }

      .sub-header-2 {
        font-size: 14.42px;
        color: $SUNSET100;
        font-weight: 500;
        text-align: right;
      }

      .no-plan-container {
        font-size: 14.42px;
        color: $SUNSET100;
        font-weight: 500;
        text-align: right;
        margin-right: 5px;
      }

      .edit-provider-plan-container {
        flex: 1;
        // font-size: 14.42px;
        color: $SUNSET100;
        font-weight: 500;
        text-align: center;
        background-color: #1b2138;
        border-radius: 5px;
        padding: 4px 5px 4px 5px;
        margin-right: 5px;
        font-size: 12px;
        line-height: 12px;
      }

      .sub-header-price {
        color: $SUNSET100;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
      }

      .count {
        font-size: 16px;
        color: $WHITE;
        text-align: right;
      }
    }
  }

  .info-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 0 48px;
    margin-bottom: 32px;

    .info-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 236px;
      height: 233px;
      background-color: $N90;
      position: relative;
      padding-bottom: 40px;

      .count {
        font-size: 64px;
        font-weight: 500;
        color: $WHITE;
        margin-bottom: -20px;
      }

      .info {
        font-size: 14.42px;
        color: $N50;
      }

      .title {
        font-size: 14.42px;
        color: $WHITE;
        position: absolute;
        bottom: 21px;
      }
    }
  }

  .edit-img {
    width: 24px;
    height: 24px;
  }

  .edit-img-btn {
    border-radius: 3px;
    background-color: #1b2138;
    display: flex;
    align-items: center;
  }
}
</style>
